<template>
  <div class="layer memo">
    <button type="button" class="btnClose" @click="cancel"></button>
    <div class="inner">
      <h2 class="layerTitle">{{locale.memo}}</h2>
      <p class="mb15 colorGrey">{{locale.message_memo_tip_1}}<br>{{locale.message_memo_tip_2}}</p>
      <textarea class="input" v-model="memo" @input="setMaxLength" @keypress.enter="save"></textarea>
      <p class="length colorGrey"><span :class="{colorRed: memoLength >= maxLength}">{{memoLength}}</span>/{{maxLength}}</p>
      <div class="btns">
        <button type="button" class="btn btnFull btnPrimary" @click="save">{{locale.save}}</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Memo',
  props: [
    'locale'
  ],
  computed: {
    memoLength () {
      return this.memo.length
    }
  },
  created () {
  },
  data () {
    return {
      memo: '',
      maxLength: 100
    }
  },
  methods: {
    setMaxLength () {
      this.memo = this.memo.slice(0, this.maxLength)
    },
    save () {
      if (window.confirm(this.locale.confirm_save)) {
        this.$emit('save', this.memo)
      }
    },
    cancel () {
      if (window.confirm(this.locale.confirm_cancel)) {
        this.close()
      }
    },
    close () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.memo {
  > .inner {
    max-width: 480px;
  }
  textarea {
    min-height: 6em;
  }
  .btns {
    width: 180px;
    margin: 30px auto 0;
  }
  .length {
    text-align: right;
  }
}
</style>
